module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('gc-order-detail-buttons-base', {
    attrs: {
      "order-detail": _vm.orderDetail,
      "show-customer-goods-btn": _vm.showCustomerGoodsBtn,
      "show-invoice-btn": _vm.showInvoiceBtn
    },
    on: {
      "goToCustomerGoods": _vm.goToCustomerGoods,
      "goToInvoice": _vm.goToInvoice
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-70621cca","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/emktcommon/orders/order/GcOrderDetailButtonsWithActions.vue
// module id = 1672
// module chunks = 8